export const REQUEST_VEHICLES = '@@VEHICLES/REQUEST_VEHICLES';
export const SUCCESS_VEHICLES = '@@VEHICLES/SUCCESS_VEHICLES';
export const FAILURE_VEHICLES = '@@VEHICLES/FAILURE_VEHICLES';

export const REQUEST_SEARCH_VEHICLES =
  '@@SEARCH_VEHICLES/REQUEST_SEARCH_VEHICLES';
export const SUCCESS_SEARCH_VEHICLES =
  '@@SEARCH_VEHICLES/SUCCESS_SEARCH_VEHICLES';
export const FAILURE_SEARCH_VEHICLES =
  '@@SEARCH_VEHICLES/FAILURE_SEARCH_VEHICLES';

export const REQUEST_VEHICLE_BY_ID = '@@VEHICLE_BY_ID/REQUEST_VEHICLE_BY_ID';
export const SUCCESS_VEHICLE_BY_ID = '@@VEHICLE_BY_ID/SUCCESS_VEHICLE_BY_ID';
export const FAILURE_VEHICLE_BY_ID = '@@VEHICLE_BY_ID/FAILURE_VEHICLE_BY_ID';

export const REQUEST_POLICIES = '@@POLICIES/REQUEST_POLICIES';
export const SUCCESS_POLICIES = '@@POLICIES/SUCCESS_POLICIES';
export const FAILURE_POLICIES = '@@POLICIES/FAILURE_POLICIES';

export const REQUEST_POLICY = '@@POLICY/REQUEST_POLICY';
export const SUCCESS_POLICY = '@@POLICY/SUCCESS_POLICY';
export const FAILURE_POLICY = '@@POLICY/FAILURE_POLICY';

export const REQUEST_PRINTABLE_DOCUMENT =
  '@@PRINTABLE_DOCUMENT/REQUEST_PRINTABLE_DOCUMENT';
export const SUCCESS_PRINTABLE_DOCUMENT =
  '@@PRINTABLE_DOCUMENT/SUCCESS_PRINTABLE_DOCUMENT';
export const FAILURE_PRINTABLE_DOCUMENT =
  '@@PRINTABLE_DOCUMENT/FAILURE_PRINTABLE_DOCUMENT';

export const REQUEST_PREFERENCE_ID = '@@POLICY/REQUEST_PREFERENCE_ID';
export const SUCCESS_PREFERENCE_ID = '@@POLICY/SUCCESS_PREFERENCE_ID';
export const FAILURE_PREFERENCE_ID = '@@POLICY/FAILURE_PREFERENCE_ID';

export const REQUEST_ENDORSEMENT = '@@ENDORSEMENT/REQUEST_ENDORSEMENT';
export const SUCCESS_ENDORSEMENT = '@@ENDORSEMENT/SUCCESS_ENDORSEMENT';
export const FAILURE_ENDORSEMENT = '@@ENDORSEMENT/FAILURE_ENDORSEMENT';

export const CLEAN_SUCCESS_ERRORS = '@@POLICY/CLEAN_SUCCESS_ERRORS';

export const CLEAR_VEHICLES_SEARCHED =
  '@@VEHICLE_BY_ID/CLEAR_VEHICLES_SEARCHED';

export default (state: any, action: any) => {
  let loadingPool = state.loadingPool;

  switch (action.type) {
    case REQUEST_VEHICLES:
      state.loadingPool.push(action.type);
      return {
        ...state,
        // vehicles: [],
        loadingPool: state.loadingPool,
        loading: !!state.loadingPool.length,
      };

    case SUCCESS_VEHICLES:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_VEHICLES
      );

      return {
        ...state,
        vehicles: action.payload,
        loadingPool,
        loading: !!loadingPool.length,
      };

    case FAILURE_VEHICLES:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_VEHICLES
      );
      return {
        ...state,
        vehicles: [],
        loadingPool,
        loading: !!loadingPool.length,
      };

    case REQUEST_SEARCH_VEHICLES:
      return {
        ...state,
        // vehicles: [],
        loadingPool: state.loadingPool,
        loading: true,
      };

    case SUCCESS_SEARCH_VEHICLES:
      return {
        ...state,
        hasMoreData: action.payload.length > 1 ? true : false,
        vehiclesSearched: [...state.vehiclesSearched, ...action.payload],
        loading: false,
      };

    case CLEAR_VEHICLES_SEARCHED:
      return {
        ...state,
        hasMoreData: false,
        vehiclesSearched: [],
        loading: false,
      };

    case FAILURE_SEARCH_VEHICLES:
      return {
        ...state,
        vehiclesSearched: [],
        loading: false,
      };

    case REQUEST_VEHICLE_BY_ID:
      state.loadingPool.push(action.type);
      return {
        ...state,
        vehicle: {},
        loadingPool: state.loadingPool,
        loading: !!state.loadingPool.length,
      };

    case SUCCESS_VEHICLE_BY_ID:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_VEHICLE_BY_ID
      );
      return {
        ...state,
        vehicle: action.payload,
        loadingPool,
        loading: !!loadingPool.length,
      };

    case FAILURE_VEHICLE_BY_ID:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_VEHICLE_BY_ID
      );

      return {
        ...state,
        vehicle: {},
        loadingPool,
        loading: !!loadingPool.length,
      };

    case REQUEST_POLICIES:
      state.loadingPool.push(action.type);
      return {
        ...state,
        // vehicles: [],
        loadingPool: state.loadingPool,
        loading: !!state.loadingPool.length,
      };

    case SUCCESS_POLICIES:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_POLICIES
      );

      const searchedPolicies = action.payload.find(
        (policy: any) => new Date() >= new Date(policy.starts_at)
      );

      return {
        ...state,
        policies: action.payload,
        userEnabled: !!searchedPolicies,
        loadingPool,
        loading: !!loadingPool.length,
      };

    case FAILURE_POLICIES:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_POLICIES
      );
      return {
        ...state,
        policies: [],
        loadingPool,
        loading: !!loadingPool.length,
      };

    case REQUEST_POLICY:
      state.loadingPool.push(action.type);
      return {
        ...state,
        policy: {},
        loadingPool: state.loadingPool,
        loading: !!state.loadingPool.length,
      };

    case SUCCESS_POLICY:
      loadingPool = state.loadingPool.filter((p: any) => p !== REQUEST_POLICY);

      return {
        ...state,
        policy: action.payload,
        loadingPool,
        loading: !!loadingPool.length,
      };

    case FAILURE_POLICY:
      loadingPool = state.loadingPool.filter((p: any) => p !== REQUEST_POLICY);

      return {
        ...state,
        policy: {},

        loadingPool,
        loading: !!loadingPool.length,
      };

    case REQUEST_PRINTABLE_DOCUMENT:
      state.loadingPool.push(action.type);
      return {
        ...state,
        success: {},
        errors: {},
        loadingPool: state.loadingPool,
        loading: !!state.loadingPool.length,
      };

    case SUCCESS_PRINTABLE_DOCUMENT:
      loadingPool = state.loadingPool.filter(
        (p: any) => p !== REQUEST_PRINTABLE_DOCUMENT
      );

      return {
        ...state,
        success: {
          send_email: action.payload,
        },
        errors: {},
        loadingPool,
        loading: !!loadingPool.length,
      };

    case FAILURE_PRINTABLE_DOCUMENT:
      loadingPool = state.loadingPool.filter((p: any) => p !== REQUEST_POLICY);

      return {
        ...state,
        policy: {},
        errors: {
          send_email: action.payload,
        },
        success: {},
        loadingPool,
        loading: !!loadingPool.length,
      };

    case REQUEST_PREFERENCE_ID:
      return {
        ...state,
        preferenceId: action.payload,
      };

    case FAILURE_PREFERENCE_ID:
      return {
        ...state,
        preferenceId: action.payload,
      };

    case REQUEST_ENDORSEMENT:
      return {
        ...state,
        loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_ENDORSEMENT:
      return {
        ...state,
        success: {
          endorsement: action.payload || 'success',
        },
        errors: {},
        loading: false,
      };

    case FAILURE_ENDORSEMENT:
      return {
        ...state,
        errors: {
          endorsement: action.payload,
        },
        success: {},
        loading: false,
      };

    case CLEAN_SUCCESS_ERRORS:
      return {
        ...state,
        errors: {},
        success: {},
      };

    default:
      return state;
  }
};
